import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		DokladSk: [],
		ProvozovnaId: [] as (DropdownItem & { DokladSk: number })[],
		DokladDruh: [] as DropdownItem[],
		PlatbaPzn: [] as DropdownItem[],
	},
	filter: {
		DokladSk: null as number | null,
		DokladDruh: null as string | null,
		ProvozovnaId: null as number | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
